var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"past-visit-chart-review mt-4",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[(!_vm.userIsPatient)?_c('SignedVisitNote',{attrs:{"item":_vm.item}}):_c('SignedVisitNotePatient',{attrs:{"item":_vm.item}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }